<template>
  <a
    class="btn"
    :class="btnClasses"
    :disabled="disabled"
    @click.prevent="onClick"
  >
    <slot />
  </a>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'default',
    },
    size: {
      type: String,
    },
    active: {
      type: Boolean,
      default: false,
    },
    modifiers: {
      type: String,
    },
    block: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    btnClasses() {
      const classes = [];

      // Type classes
      switch (this.type) {
        case 'outline':
          classes.push('btn-outline-primary');
          break;
        default:
          classes.push(`btn-${this.type}`);
      }

      if (this.block) {
        classes.push('btn-block');
      }

      if (this.size) {
        classes.push(`btn-${this.size}`);
      }

      if (this.modifiers) {
        classes.push(this.modifiers);
      }

      if (this.active) {
        classes.push('active');
      }

      return classes;
    },
  },
  methods: {
    onClick(evt) {
      if (!this.disabled) {
        this.$emit('click', evt);
      }
    },
  },
};
</script>
